import type { FC, ReactNode } from 'react';
import { CreditLimit, SceneWrapper, SectionTitle } from '~/components';
import { currencyParser } from '~/modules';
import { ButtonComponent, FooterWrapper } from './styles';
type CreditSimulationSummaryProps = {
  onSimulate: () => void;
  onSimulateAgain: () => void;
  items: Record<string, string>;
  requestedCreditSimulationValue: number;
};

const CreditSimulationSummary: FC<CreditSimulationSummaryProps> = ({
  items,
  onSimulate,
  onSimulateAgain,
  requestedCreditSimulationValue,
}) => {
  const footer: ReactNode = (
    <FooterWrapper>
      <ButtonComponent
        id="btn-simulate-again"
        onPress={onSimulateAgain}
        transparent
        fullWidth
      >
        SIMULAR NOVAMENTE
      </ButtonComponent>
      <ButtonComponent id="btn-simulate-credit" onPress={onSimulate} fullWidth>
        SOLICITAR CRÉDITO
      </ButtonComponent>
    </FooterWrapper>
  );
  return (
    <SceneWrapper footer={footer}>
      <SectionTitle>Essa é a parcela ideal para você?</SectionTitle>
      <CreditLimit
        title="Valor solicitado"
        value={currencyParser(requestedCreditSimulationValue)}
        details={items}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationSummary;
